<template>
	<div class="record-cls">
		<section class="audio-cls" v-if="row.channelId === 'phone'">
			<audio :src="auditFilePath" class="audio-cls" controls></audio>
		</section>
		<section class="sms-box" v-else-if="row.channelId == 'sms'">
			<span v-if="smsInfo.sendStatus === 'ready'" class="time" :class="smsInfo.sendStatus">预约时间：{{smsInfo.scheduleTime | formatDate}}</span>
			<span v-else-if="smsInfo.sendStatus === 'sent'" class="time">发送时间：{{smsInfo.sendTime | formatDate}}</span>
			<span class="text">{{smsInfo.smsBody}}</span>
		</section>
		<section v-else class="im-cls">
			<historyList :customerId="row.custId" :sessionId="row.tuid" />
		</section>
	</div>
</template>

<script>
export default {
	name: 'CommunicateRecord',
	props: ['row'],
	data() {
		return {
			auditFilePath: '',
			smsInfo: {},
		}
	},
	watch: {
		row: {
			handler() {
				this.getAudioFile();
			},
			immediate:true,
			deep: true
		},
	},
	methods: {
		getAudioFile() {
			if(this.row.channelId == 'phone') {
				if(this.row.dataList && this.row.dataList.length > 0) {
					for(const _item of this.row.dataList) {
						if(_item.dataType === 'UCID') {
							if(this.row.channelIdentify === 'phone') {
								this.$api.apiPostLarksWitchLocation({
									projectCode: this.row.brandId,
									uuid: _item.dataId
								}).then(response => {
									if(response.errcode != 0) return;
									this.auditFilePath = response.data.http_file_url;
								});
							}
							return;
						}
					}
				}
			} else if(this.row.channelId == 'sms') {
				this.$api.apiPostSmsSelByIncident({brand: this.row.brandId, incidentId: this.row.tuid}).then(response => {
					if(response.errcode != 0) return;
					this.smsInfo = response?.data?.smsrsult;
				});
			}
			
		}
	}
}
</script>

<style lang="scss" scoped>
.record-cls {
	width: 100%;
	background: #F9FCFF;
	border-radius: 0px 0px 3px 0px;
	border: 1px solid #DEDFDF;
	padding: 13px;
	box-sizing: border-box;

	& > .audio-cls > audio {
		width: 100%;
		height: 35px;
		border-radius: 35px;
		border: 1px solid #DEDFDF;
	}

	& > .im-cls {
		width: 100%;
		height: 320px;
		overflow-x: hidden;
		overflow-y: auto;
	}

	& > .sms-box {
		width: 100%;
		padding: 12px;
		box-sizing: border-box;
		font-size: 15px;
		color: #333;
		line-height: 30px;
		letter-spacing: .5px;

		& > .time {
			display: block;
			line-height: 40px;
			text-align: center;
			font-size: 12px;

			&.ready {
				color: #e6a23c;
			}
		}

		& > .text {
			text-indent: 2em;
		}
	}

	& .content-cls {
			width: calc(100% + 38px + 30px);
			background: #F9FCFF ;
			position: relative;
			left: -30px;
			border-top: 1px solid #DEDFDF;
			padding: 10px;
			box-sizing: border-box;

			& > audio {
				width: 100%;
				height: 35px;
				border-radius: 35px;
				border: 1px solid #DEDFDF;
			}

			& > .im-cls {
				width: 100%;
				height: 240px;
			}

			& > .sms-box {
				width: 100%;
				padding: 12px;
				box-sizing: border-box;
				font-size: 15px;
				color: #333;
				line-height: 30px;
				letter-spacing: .5px;

				& > .time {
					display: block;
					line-height: 40px;
					text-align: center;
					font-size: 12px;

					&.ready {
						color: #e6a23c;
					}
				}

				& > .text {
					text-indent: 2em;
				}
			}
		}
}
</style>